var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-avatar',{staticStyle:{"backgroundColor":"#00BFBF"},attrs:{"src":_vm.avatar,"size":_vm.size,"shape":"circle"}},[_vm._v(" "+_vm._s(_vm.avatar ? "" : _vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }